export default __webpack_public_path__ + "static/abajo-derecha-af8fe764bb0361717c99b2a21901ce13.png";